import { render } from "./EditConfirmModal.vue?vue&type=template&id=54e103a0"
import script from "./EditConfirmModal.vue?vue&type=script&lang=js"
export * from "./EditConfirmModal.vue?vue&type=script&lang=js"
script.render = render

export default script